import {Link, Text} from 'platform/foundation';

import {ReactNode} from 'react';

import {ImportVehicleAttribute} from '../types/ImportVehicle';

export function isUrl(value: string): boolean {
  const trimmed = value.trim();
  return trimmed.startsWith('http://') || trimmed.startsWith('https://');
}

export type AttributeRow = {label: string; content: ReactNode};

export function attributeToRow(
  attr: ImportVehicleAttribute,
  translateLabel: (raw: string) => string
): AttributeRow {
  const isLink = isUrl(attr.value);
  return {
    label: translateLabel(attr.label),
    content: isLink ? (
      <Link
        href={attr.value}
        target="_blank"
        rel="noopener noreferrer"
        size="xSmall"
        title={attr.value}
        overflowWrap="anywhere"
      />
    ) : (
      <Text size="xSmall" alternative overflowWrap="anywhere">
        {attr.value}
      </Text>
    ),
  };
}
